import { render } from "./TopBarLeftHolder.vue?vue&type=template&id=0fa3a129&ts=true"
import script from "./TopBarLeftHolder.vue?vue&type=script&lang=ts"
export * from "./TopBarLeftHolder.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__